import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'react-bootstrap';
import ModuleHeader from '../../components/ModuleHeader';
import { businessPartnerOperations } from "./state";
import { ADD_BUSINESS_PARTNER, EDIT_BUSINESS_PARTNER } from "./routes";
import TableTemplate from '../../components/TableTemplate';
import { DEFAULT_PAGE_NUM, EMPTY_COUNT } from '../../../utils/constants';
class BusinessPartner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: props.pageSize,
            page: this.props.page
        };
    }

    componentDidMount() {
        if(EMPTY_COUNT <= this.props.path.indexOf(this.props.location.pathname)){
            this.props.fetchDefault({ businessPartnerCode: this.props.businessPartnerCode }, this.state.size, this.state.page);
        }else{
            this.props.fetchDefault({ businessPartnerCode: this.props.businessPartnerCode }, this.state.size, DEFAULT_PAGE_NUM);
        }
    }

    copyBusinessPartner = (data) => {
        if (undefined === data) {
            this.props.history.push(ADD_BUSINESS_PARTNER);
        } else {
            this.props.history.push({
                pathname: ADD_BUSINESS_PARTNER + "/" + data.userCode,
                state: { copy: true }
            })
        }
    }

    getBusinessPartner = (data) => {
        this.props.history.push(EDIT_BUSINESS_PARTNER + "/" + data.userCode)
    };

    setRowLines = (rows) => {
        this.setState({ size: rows, page: DEFAULT_PAGE_NUM });
        this.props.fetchDefault({ businessPartnerCode: this.props.businessPartnerCode }, rows, DEFAULT_PAGE_NUM);
    }

    nextPage = () => {
        this.props.fetchDefault({ businessPartnerCode: this.props.businessPartnerCode }, this.state.size, this.state.page + DEFAULT_PAGE_NUM);
        this.setState({ page: this.state.page + DEFAULT_PAGE_NUM });
    }

    prevPage = () => {
        this.props.fetchDefault({ businessPartnerCode: this.props.businessPartnerCode }, this.state.size, this.state.page - DEFAULT_PAGE_NUM);
        this.setState({ page: this.state.page - DEFAULT_PAGE_NUM });
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader
                        title={"取引先一覧"}
                        size={this.state.size}
                        filter={true}
                        setRowLines={this.setRowLines.bind(this)}
                        nextPage={this.nextPage}
                        prevPage={this.prevPage}
                        maxPage={this.props.pageCount}
                        currPage={this.state.page}
                    />

                    <TableTemplate
                        {...this.props}
                        rowButtons={[
                            {
                                onClick: this.getBusinessPartner,
                                icon: ['far', "edit"],
                                bsStyle: "link"
                            },
                            {
                                onClick: this.copyBusinessPartner,
                                icon: ['far', "copy"],
                                bsStyle: "link"
                            }
                        ]}
                    />
                    <center>
                        <Button
                            className="button-common"
                            onClick={() => this.copyBusinessPartner()}
                        >
                            新規登録
                        </Button>
                    </center>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        businessPartnerCode: state.auth.credentials.riyo_kigyo_id,
        tableHeader: state.businessPartner.tableHeader,
        tableList: state.businessPartner.list,
        tableColumns: state.businessPartner.tableColumns,
        pageCount: state.businessPartner.pageCount,
        pageSize: state.businessPartner.pageSize,
        page: state.bpOrder.page,
        path: state.bpOrder.path
    }
};

const mapDispatchToProps = {
    fetchDefault: businessPartnerOperations.fetchDefault,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessPartner);